import Header from "../component/Header";
import Footer from "../component/Footer"
import Brandlogos from './Brandlogos';
import { useSelector } from "react-redux";
import Male from '../component/Male';
import Female from '../component/Female';
import Kids from '../component/Kids';
import Stephi from '../component/Stephi';
import './Header.css';
import SectionImageSlider from "../pages/Intropage/Banner";

export default function App() {

  localStorage.setItem("myPage", 0);
  const genderData = useSelector(state => state.category?.gender);

  return (
    <div className='home-page'>
      <Header />
      {(genderData === 'male' ? <Male /> : '')}
      {(genderData === 'female' ? <Female /> : '')}
      {(genderData === 'kids' ? <Kids /> : '')}
      {(genderData === 'life' ? <Stephi /> : '')}
        {genderData === null && <SectionImageSlider />}
        {genderData !== null && <Brandlogos/>}
      <Footer />
    </div>
  )
}